module.exports = __webpack_public_path__ + "img/award.e3f9daea.png";